import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const axiosInstance = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for logging
axiosInstance.interceptors.request.use(
  config => {
    console.log(`API Request: ${config.method?.toUpperCase()} ${config.url}`);
    return config;
  },
  error => {
    console.error('Request Error:', error);
    return Promise.reject(error);
  }
);

// Add response interceptor for error logging
axiosInstance.interceptors.response.use(
  response => {
    console.log(`API Response: ${response.status} ${response.config.url}`);
    return response;
  },
  error => {
    console.error('API Error:', error.response?.status, error.response?.data || error.message);
    return Promise.reject(error);
  }
);

export const api = {
  // Characters
  getCharacters: async () => {
    try {
      const response = await axiosInstance.get('/characters');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch characters:', error);
      return [];
    }
  },

  getCharacter: async (id) => {
    const response = await axiosInstance.get(`/characters/${id}`);
    return response.data;
  },

  createCharacter: async (character) => {
    const response = await axiosInstance.post('/characters', character);
    return response.data;
  },

  updateCharacter: async (id, character) => {
    const response = await axiosInstance.put(`/characters/${id}`, character);
    return response.data;
  },

  deleteCharacter: async (id) => {
    const response = await axiosInstance.delete(`/characters/${id}`);
    return response.data;
  },

  importCharacters: async (data) => {
    const response = await axiosInstance.post('/characters/import', data);
    return response.data;
  },

  moveCharacter: async (id, folderId) => {
    const response = await axiosInstance.patch(`/characters/${id}/move`, { folderId });
    return response.data;
  },

  // Folders
  getFolders: async () => {
    try {
      const response = await axiosInstance.get('/folders');
      return response.data;
    } catch (error) {
      console.error('Failed to fetch folders:', error);
      return [];
    }
  },

  createFolder: async (folder) => {
    const response = await axiosInstance.post('/folders', folder);
    return response.data;
  },

  updateFolder: async (id, folder) => {
    const response = await axiosInstance.put(`/folders/${id}`, folder);
    return response.data;
  },

  deleteFolder: async (id) => {
    const response = await axiosInstance.delete(`/folders/${id}`);
    return response.data;
  },
};

export default api;
